import { createContext } from 'react';

type TargetSelectorContextValue = {
  isTargetSelectorOpen: boolean;
  openTargetSelector: () => void;
  closeTargetSelector: () => void;
};

export const TargetSelectorContext = createContext<TargetSelectorContextValue | undefined>(undefined);
